import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  EnvironmentProviders,
  ErrorHandler,
  makeEnvironmentProviders,
} from '@angular/core';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { InsightsInterceptor } from './interceptor/insights.interceptor';
import { InsightsService } from './services/insights.service';

export function provideInsights(): EnvironmentProviders {
  return makeEnvironmentProviders([
    InsightsService,
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InsightsInterceptor,
      multi: true,
    },
  ]);
}
